<template>
  <h2>Intsidendid väljaspool Ukrainat</h2>

  <div id="leaflet"></div>

  <section class="points-list">
    <label
      v-for="({ featureData, featureOnMap }, i) in features"
      :class="{
        selected: i === selectedFeatureIndex,
      }"
    >
      <input type="radio" :value="i" v-model="selectedFeatureIndex" />
      <div v-html="featureData.popupText"></div>
    </label>
  </section>

  <div class="pattern"></div>
</template>

<style>
#kaart {
  --section-color: #0064fa;
  --section-secondary-color: #0000ba;
  --section-tertiary-color: #a5e6e9;
  --line: #d5d8dd;
  --gray: #717c8e;
  --lightest: #eef3f6;
  --text-color: #262626;

  font-family: GT Eesti, Arial, sans-serif;
  color: var(--text-color);

  font-size: clamp(12px, 2.2vw, 15px);
  line-height: 1;
  -webkit-font-smoothing: antialiased;

  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 3fr 1fr 4px;

  width: 100%;
  height: 100%;

  -webkit-tap-highlight-color: transparent;
}

::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-thumb {
  background: #717c8e;
  /*border-radius: 4px;*/
}
::-webkit-scrollbar-thumb:hover {
  background: #262626;
}
::-webkit-scrollbar-track {
  /*background: #eef3f6;*/
  background: #fff;
}
</style>

<style scoped>
#leaflet {
  width: 100%;
  height: 100%;
}

.points-list {
  /*background-color: var(--lightest);*/
  border-top: 1px solid var(--gray);
  /*border-bottom: 1px solid var(--gray);*/

  overflow-x: hidden;
  overflow-y: auto;

  display: flex;
  flex-direction: column;
}

.points-list label {
  cursor: pointer;

  display: flex;
  align-items: center;

  position: relative;

  box-sizing: border-box;
  padding: 0.5em 2px;

  border-left: 0.25em solid white;

  transition: 220ms ease;
}

.points-list label:hover,
.points-list label.selected {
  border-color: var(--gray);
}

.points-list label.selected {
  background-color: var(--lightest);
}

.points-list input {
  position: absolute;
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
}

.points-list label > div {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25em;
}

.pattern {
  height: 4px;
  width: 100%;

  color: var(--gray);

  background-image: radial-gradient(
    circle at 1px 1px,
    currentColor 1px,
    transparent 0
  );
  background-size: 4px 4px;

  user-select: none;
  pointer-events: none;
}
</style>

<script>
import featuresData from "./data/features.json";
import ukrainaMapData from "./data/ukraina-basemap.json";

export default {
  data: () => ({
    // containerWidth: 0,

    map: null,

    features: [],
    selectedFeatureIndex: -1,
  }),
  mounted() {
    // window.addEventListener("resize", this.onResize);
    // this.onResize();

    this.initMap();
  },
  beforeDestroy() {
    // window.removeEventListener("resize", this.onResize);
  },
  methods: {
    /*onResize() {
      const bounds = this.containerElement.getBoundingClientRect();
      const { width, height } = bounds;
      // console.log("onResize", width, height);
      if (width < 555) {
        this.containerElement.classList.add("small");
      } else {
        this.containerElement.classList.remove("small");
      }
      this.containerWidth = width;
    },*/

    async initMap() {
      this.map = L.map("leaflet", {
        preferCanvas: true,
        minZoom: 3,
        onMapReady(map) {
          setTimeout(() => {
            map.invalidateSize(true);
          }, 1000);
        },
      });

      const tileServer = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
      const attribution =
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
      const tiles = L.tileLayer(tileServer, { attribution });
      tiles.addTo(this.map);

      L.control.scale().addTo(this.map);

      // points / markers
      const geojson = L.geoJSON(featuresData, {
        pointToLayer: (geoJsonPoint, latlng) => {
          return L.circleMarker(latlng, {
            color: "#c00",
          });
        },
        onEachFeature: (featureData, featureOnMap) => {
          const o = {
            featureData,
            featureOnMap,
          };

          // click event
          featureOnMap.on("click", this.onMarkerClick);

          // popup
          try {
            const { properties } = featureData;
            const [date, title] = properties["name"].split("|");
            let popupText = `<strong>${date.trim()}</strong><div>${title.trim()}</div>`;
            if (properties["description"]) {
              popupText += `<small>${properties["description"]}</small>`;
            }

            featureOnMap.bindPopup(popupText, {
              maxWidth: 200,
            });

            o.featureData.popupText = popupText;
          } catch (e) {
            console.log(e); // invalid geojson
          }

          this.features.push(o); // save for list
        },
      });

      // Ukraina
      const ukraina = L.geoJSON(ukrainaMapData, {
        color: "rgb(0, 91, 187)",
        weight: 2,

        fillColor: "rgb(255, 213, 0)",
        fillOpacity: 0.022,
      }).addTo(this.map);

      // add on layer, add layer on map
      L.layerGroup([geojson]).addTo(this.map);

      // wait for render
      await this.$nextTick();

      // double check
      this.map.invalidateSize();
      window.setTimeout(this.map.invalidateSize, 500);

      // zoom level
      this.map.fitBounds(geojson.getBounds(), { padding: [30, 30] });

      // open attribution links in new tab
      const links = document.querySelectorAll("a");
      links.forEach((a) => {
        // console.log(a);
        if (a.href.startsWith("http")) {
          a.setAttribute("target", "_blank");
        }
      });

      // Get coordinates
      /*this.map.on("click", (e) => {
        const { latlng } = e;
        console.log([latlng.lat, latlng.lng]);
      });*/
    },

    flyToMarker(marker) {
      let zoomLvl = this.map.getZoom();

      if (zoomLvl < 8) {
        zoomLvl = 8;
      }

      this.map.flyTo(marker.getLatLng(), zoomLvl, {
        animate: false,
        // duration: 1,
      });
      marker.openPopup();
    },

    onMarkerClick(e) {
      // console.log(e);
      this.selectedFeatureIndex = this.features.findIndex(
        (x) => x.featureData.popupText === e.target.feature.popupText
      );
    },
  },
  watch: {
    selectedFeatureIndex(newValue) {
      this.flyToMarker(this.features[newValue].featureOnMap);
    },
  },
};
</script>
